<div class="plate-container">
  <div class="dialog-header">
    <div class="header-title">
      <div class="icon-box">
        <mat-icon>assignment</mat-icon>
      </div>
      <h2 mat-dialog-title>Plate Details</h2>
    </div>
    <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div mat-dialog-content class="dialog-body">
    <div class="details-grid">
      <div class="detail-item" *ngFor="let item of displayData">
        <span class="label">{{ item.label }}</span>
        <span class="value" [class.empty]="!item.value || item.value === '--'">
          {{ item.value || '--' }}
        </span>
      </div>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div mat-dialog-actions class="dialog-footer">
    <button mat-stroked-button (click)="dialogRef.close()">Close</button>
  </div>
</div>